const downloadJsonFile = (jsonData, filename = 'data.json') => {
  try {
    // Преобразуем JSON объект в строку с форматированием (отступы для читаемости)
    const jsonString = JSON.stringify(jsonData, null, 2);
    
    // Создаем Blob объект с JSON данными
    const blob = new Blob([jsonString], { type: 'application/json' });
    
    // Создаем URL для Blob
    const url = URL.createObjectURL(blob);
    
    // Создаем временную ссылку для скачивания
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    
    // Добавляем ссылку в DOM, кликаем по ней и удаляем
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Освобождаем память, удаляя созданный URL
    URL.revokeObjectURL(url);
    
    // alert(`Файл ${filename} успешно скачан`);
  } catch (error) {
    alert(`Ошибка при скачивании файла:${error}`);
  }
};

export default downloadJsonFile;